import "./result.css";
import { Result } from './result';
export default Result;